import { useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { DashboardFormWrapper } from '../dashboard';
import { GateOutsPage } from './GateOutsComponents';
import { GateOutsViewHeader, GateOutsViewForm } from './GateOutsViewComponents';
import { useGateOutQuery } from '../../hooks';
import { RoleGuard } from '../../routes';
import { GateOutReceiptPrint } from '../containers/GateInReceiptPrint';

export const GateOutsView = () => {
  const params: any = useParams();
  const { data: request, isFetching } = useGateOutQuery(params.id);
  const [isPrinting, setIsPrinting] = useState(false);

  if (isFetching) return <></>;
  if (!request) return <Navigate to={'/dashboard/gateouts'} replace />;

  return (
    <RoleGuard roles={['TRADER']} isMobile negative>
      <GateOutsPage>
        <GateOutsViewHeader request={request} onPrint={() => setIsPrinting(true)} />
        <DashboardFormWrapper flow={'row'}>
          <GateOutsViewForm request={request} />
        </DashboardFormWrapper>
      </GateOutsPage>
      {isPrinting && (
        <GateOutReceiptPrint container={request.container} onPrinted={() => setIsPrinting(false)} />
      )}
    </RoleGuard>
  );
};
